export const toPrice = (num) => parseFloat(num).toFixed(2);

export const calculateTotalToPay = (itemsPrice, promoPrice, jackpotMatchAmount = 0) => {
  const isPromo = promoPrice < itemsPrice;
  const isJackpotMatch = jackpotMatchAmount > 0;

  if (isPromo) {
    if (isJackpotMatch) return Math.max(0,promoPrice - jackpotMatchAmount);
    return promoPrice;
  }

  if (isJackpotMatch) return Math.max(0,itemsPrice - jackpotMatchAmount);
  return toPrice(itemsPrice);
};

